export const PAGE_SIZE = 12;
export const RELATION_TYPES = {
  instructor: 'instructor',
  student: 'student'
};

// Monolith support only
export const TAB_NAMES = {
  instructor: gettext => gettext('Instructor'),
  Instructor: gettext => TAB_NAMES.instructor(gettext),
  // alias
  student: gettext => gettext('Student'),
  Student: gettext => TAB_NAMES.student(gettext) // alias
};
//# sourceMappingURL=constants.js.map